module.exports = __webpack_public_path__ + "media/images/home/main/screen1-63e236b9236e81edd3a17f60828e1666.png";